import React from 'react';
import './App.css';
import './Navbar.css';
import { AiOutlineLogout } from "react-icons/ai"
import { BsListUl, BsPerson } from "react-icons/bs"
import AppLang from './AppLang.json';

import { useNavigate } from "react-router-dom";

class Navbar extends React.Component {

	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}
	
	handleClick(page) {

		const navigate = this.props.navigate;

		if (page === "/logout") {
			this.props.logoutClearVariables();
			navigate("/login");
		} else {
			navigate(page);
		}

		this.props.closeNavbar();
	}
	
	render() {

		var navbarOpenYN = this.props.navbarOpenYN;
		if (!navbarOpenYN) {
			return (<div></div>);
		}
		
		return (
			<div className="Navbar">
				<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/apps")}
				>
					<div className="NavbarLinkColumn1">
						<BsListUl style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">{this.props.getLang(AppLang, "apps")}</div>				  					  
				</div>
				<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/myaccount")}
				>
					<div className="NavbarLinkColumn1">
						<BsPerson style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">{this.props.getLang(AppLang, "myAccount")}</div>
				</div>
				<div
				  role="menuitem"
				  className="NavbarLink"
				  onClick={() => this.handleClick("/logout")}
				>
					<div className="NavbarLinkColumn1">
						<AiOutlineLogout style={{ color: "white", width: "25px", height: "25px" }} />
					</div>
					<div className="NavbarLinkColumn2">Logout</div>
				</div>
			</div>
		);
	}
}

export default function NavbarFunction(props) {
	const navigate = useNavigate();
	return <Navbar {...props} navigate={navigate} />;
}

